
export const holidayHoursActions = self => ({
  update(oh) {
    self.set('openHour', oh.openHour)
    self.set('closeHour', oh.closeHour)
    self.set('title', oh.title)
    self.set('date', oh.date)
    self.set('closed', oh.closed)
  },
  set(key, value) {
    self[key] = value
  }
})